import React from 'react';
import PaginatedPrioritySection from './PaginatedPrioritySection';
import EditableText from './EditableText';

export default function DevelopmentAreasPage({ data, personName }) {
  const header = (
    <>
      <h2 className="pdf-section-heading">
        <span className="pdf-section-heading__badge">4</span>
        <EditableText
          as="span"
          path="keyDevelopmentAreas.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="div"
        className="pdf-body-text"
        path="keyDevelopmentAreas.pagePara"
        variant="block"
      />
    </>
  );

  return (
    <PaginatedPrioritySection
      header={header}
      tableContents={data.tableContents}
      summaryContentPath="keyDevelopmentAreas.summaryContent"
      slicePageContent="keyDevelopmentAreas"
      startPageNumber={10}
      personName={personName}
    />
  );
}
